import { css, polished } from 'jimu-core';
import { buttonStyles } from './button';
import { formValidation } from './text-input';
function getInputHeight(inputVarsBySize, inputBorderWidth) {
    const heightInner = polished.math(`
    ${inputVarsBySize.fontSize} * ${inputVarsBySize.lineHeight} +
    ${inputVarsBySize.paddingY} * 2`);
    return inputBorderWidth.toString() === '0'
        ? heightInner
        : `calc(${heightInner} + ${inputBorderWidth} * 2)`;
}
function getInputSizingStyles(inputVars, size) {
    const inputVarsBySize = inputVars.sizes[size];
    return `
    height: ${inputVarsBySize.height !== 'auto'
        ? inputVarsBySize.height
        : getInputHeight(inputVarsBySize, inputVars.border.width)};
    padding: ${inputVarsBySize.paddingY} ${inputVarsBySize.paddingX};
    font-size: ${inputVarsBySize.fontSize};
    line-height: ${inputVarsBySize.lineHeight};
    border-radius: ${inputVarsBySize.borderRadius};
  `;
}
const textInputStyles = (props) => {
    var _a;
    const size = props.bsSize || props.size;
    const type = props.type;
    const theme = props.theme;
    const inputVars = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.input;
    return inputVars && css `
    display: block;
    width: 100%;
    color: ${inputVars.color};
    background-color: ${inputVars.bg};
    background-clip: padding-box;
    border: ${inputVars.border.width} solid ${theme.sys.color.divider.input};
    box-shadow: ${inputVars.boxShadow};
    transition: ${inputVars.transition};
    ${!size && getInputSizingStyles(inputVars, 'default')}

    -moz-appearance:textfield;

    &::-ms-expand {
      background-color: transparent;
      border: 0;
    }

    &:focus {
      color: ${inputVars.focus.color};
      background-color: ${inputVars.focus.bg};
      outline: none !important;
      box-shadow: none !important;
    }

    /* Placeholder */
    &::placeholder {
      color: ${inputVars.placeHolderColor};
      opacity: 1;
    }

    /* Disabled and read-only inputs */
    &:disabled,
    &[readonly] {
      background: ${inputVars.disabled.bg};
      border-color: ${inputVars.disabled.borderColor};
      opacity: 1;
    }

    &:disabled {
      color: ${inputVars.disabled.color};
      -webkit-text-fill-color: ${inputVars.disabled.color};
    }

    ${(type === 'file' || type === 'range') && `
      display: block;
      width: 100%;
    `}

    ${type === 'textarea' && `
      height: auto;
    `}

    /* Form control sizing */

    ${size === 'sm' && getInputSizingStyles(inputVars, 'sm')}

    ${size === 'lg' && getInputSizingStyles(inputVars, 'lg')}
  `;
};
export const numericInputStyles = (props) => {
    var _a, _b, _c;
    const theme = props.theme;
    const inputVars = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.input;
    const inputVarsBySize = inputVars.sizes[(_b = props.size) !== null && _b !== void 0 ? _b : 'default'];
    return inputVars && css `
    display: flex;
    flex-direction: row-reverse;
    position: relative;
    height: ${inputVarsBySize.height !== 'auto' ? inputVarsBySize.height : getInputHeight(inputVarsBySize, inputVars.border.width)};

    &:focus-within {
      outline: 1px solid ${inputVars.focus.borderColor};
    }

    .jimu-numeric-input-input-wrap {
      flex: 1;
    }
    .jimu-numeric-input-input {
      ${textInputStyles(props)}
    }
    .jimu-numeric-input-handler-wrap {
      width: 1.25rem;
      display: none;
      flex-direction: column;
      align-content: stretch;
      margin-left: -1px;
      border-left: 1px solid ${theme.sys.color.divider.input};
      position: absolute;
      top: 1px;
      bottom: 1px;
      right: 1px;
    }
    &.show-handlers {
      .jimu-numeric-input-handler-wrap {
        display: flex;
      }
    }
    .jimu-numeric-input-handler {
      ${buttonStyles({
        theme: theme,
        size: 'sm'
    })}
      flex: 1;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .jimu-icon {
        margin: 0;
      }
    }
    .jimu-numeric-input-handler-up,
    .jimu-numeric-input-handler-down {
      border: 0;
    }
    .jimu-numeric-input-handler-up {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    .jimu-numeric-input-handler-down {
      margin-top: -1px;
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-top: 1px solid ${(_c = inputVars === null || inputVars === void 0 ? void 0 : inputVars.border) === null || _c === void 0 ? void 0 : _c.color};
    }

    &.is-invalid .jimu-numeric-input-input {
      ${formValidation(false, theme)}
    }
  `;
};
